<template>
  <div class="s-record" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnRecord.src" :src="btnRecord.src" :style="{...btnRecord.style}" alt="" @click="recordFun">
    <SVersionModalReceiveLog ref="SVersionModalReceiveLog"/>
  </div>
</template>

<script>
import SVersionModalReceiveLog from './_components/VersionModalReceiveLog.vue'
import SAnimateImage from "@/components/BuilderComponents/AnimateImage/index.vue";
export default {
  name: 'SVersionRecord',
  components: { SAnimateImage, SVersionModalReceiveLog },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnRecord: {
      type: Object,
      default: () => {
        return {}
      }
    },
    needAddress: {
      type: Boolean,
      default: false
    },
    lotteryActivityId: {
      type: String,
      default: ''
    },
    request: {
      type: Function
    }
  },
  inject: {
    eventBus: {
      default: null
    },
    $MainWrap: {
      default: null
    }
  },
  computed: {
    requestAPI () {
      // eslint-disable-next-line no-undef
      return this.request ? this.request : $request
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 点击活动记录
    recordFun () {
      if (!window.$checkLogin()) return
      const params = {
        title: '抽奖记录',
        needAddress: this.needAddress
      }
      if (this.needAddress && this.lotteryActivityId) {
        params.activityId = this.lotteryActivityId
      } else {
        params.activityId = this.activityId
      }
      this.$refs.SVersionModalReceiveLog.open(params)
    }
  }
}
</script>
<style lang="scss" scoped>
.s-record{
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
</style>
